export default "__VITE_ASSET__Cld79mat__"